import { render, staticRenderFns } from "./ParticipantAdministrative.vue?vue&type=template&id=604cdeca&scoped=true&"
import script from "./ParticipantAdministrative.ts?vue&type=script&lang=ts&"
export * from "./ParticipantAdministrative.ts?vue&type=script&lang=ts&"
import style0 from "./ParticipantAdministrative.scss?vue&type=style&index=0&id=604cdeca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604cdeca",
  null
  
)

export default component.exports